export default __webpack_public_path__ + "static/media/WorkSans-Regular.dd4e2b76.woff";